import { Checkbox, FormControlLabel } from "@mui/material";

type Props = {
  currentBlock: any;
};

const CheckboxFieldPreview = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;

  return (
    <FormControlLabel
      control={<Checkbox />}
      label={label}
      sx={{
        display: "flex",
        alignItems: "center",
        "& .MuiFormControlLabel-label": {
          fontSize: "16px",
          fontWeight: "medium",
        },
      }}
    />
  );
};
export default CheckboxFieldPreview;
